import { Component, OnInit } from '@angular/core';
import { OsnovZaPlacenoOdsustvo } from './osnov-za-placeno-odsustvo';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-osnov-za-placeno-odsustvo-modal-update',
  templateUrl: './osnov-za-placeno-odsustvo-modal-update.component.html'
})
export class OsnovZaPlacenoOdsustvoModalUpdateComponent extends BaseModalUpdateComponent<OsnovZaPlacenoOdsustvo> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<OsnovZaPlacenoOdsustvo>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
  ) {
    super(modalContainerService, activeModal,modalService);
  }

  ngOnInit() {
  }

}
